<template>
    <v-autocomplete
            :label="(label)? label : 'Seleccione cuenta'"
            :items="items"
            :value="value"
            :multiple="multiple"
            :chips="chips"
            item-value="CT1_CONTA"
            item-text="CT1_DESC01"
            hide-details
            @input="actualizaValor($event)"
            @change="change($event)"
            clearable
            :readonly="readonly"
            :error-messages="errores.collect('um')"
            v-validate="validate"
            :loading="loading"
            :filter="customFilter"
            cache-items
    >
        <template slot="item" slot-scope="data">
            <v-list-tile-content>
                <v-list-tile-title>{{ data.item.CT1_DESC01}}</v-list-tile-title>
                <v-list-tile-sub-title>{{ data.item.CT1_CONTA}}</v-list-tile-sub-title>
            </v-list-tile-content>
        </template>
    </v-autocomplete>
</template>
<script>
    import mixinItem from '../mixins/items';

    export default {
        inject: ['$validator'],
        name: 'micro-unidad-select',
        props: ['multiple', 'value', 'chips', 'readonly', 'validate', 'empresa', 'label','preset'],
        mixins: [mixinItem],
        data() {
            return {
                items: [],
                loading: false,
            }
        },
        watch: {
            preset(val) {
                this.items = (val && Object.keys(val).length !== 0) ? [val] : [];
            }
        },
        $_veeValidate: {
            value() {
                return this.value;
            }
        },
        mounted() {
            this.loading = true;
            this.itemMicroCtas({empresa_id: this.empresa}, r => {
                this.items = r;
                this.loading = false;
            }, err => {
                console.log(err);
                this.loading = false;
            })
        },
        methods: {
            customFilter(item, queryText, itemText) {
                let CT1_CONTA = (item.CT1_CONTA) ? item.CT1_CONTA.toLowerCase().includes(queryText.toLowerCase()) : false;
                let CT1_DESC01 = (item.CT1_DESC01) ? item.CT1_DESC01.toLowerCase().includes(queryText.toLowerCase()) : false;
                return (CT1_CONTA || CT1_DESC01);
            },
            actualizaValor(valor) {
                this.$emit('input', valor)
            },
            change(e) {
                this.$emit('change', e);
            },
        }
    }
</script>


// WEBPACK FOOTER //
// resources/assets/js/components/MicroCtaSelect.vue